import Vue from 'vue'
import VueRouter from 'vue-router'
import HomeView from '../views/HomeView.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/HomeView',
    name: 'HomeView',
    component: () => import('../views/HomeView'),
  },

  {
    path: '/homeView2',
    name: 'homeView2',
    component: () => import('../views/HomeView'),
  },

  {
    path: '/',
    name: 'home',
    component: HomeView
  },
  {
    path: '/meeting',
    name: 'meeting',
    component: () => import('../views/Meetting'),
  },

  {
    path: '/whysponsor',
    name: 'whysponsor',
    component: () => import('../views/Whysponsor'),
  },

  {
    path: '/exibitions',
    name: 'exibitions',
    component: () => import('../views/Exibitions'),
  },


  {
    path: '/hyticket',
    name: 'hyticket',
    component: () => import('../views/Hyticket'),
  },

  {
    path: '/freeticket',
    name: 'freeticket',
    component: () => import('../views/Freeticket'),
  },

  {
    path: '/aggenda',
    name: 'aggenda',
    component: () => import('../views/Aggenda'),
  },

  {
    path: '/demo',
    name: 'demo',
    component: () => import('../views/DemoLb'),
  },

  {
    path: '/test',
    name: 'test',
    component: () => import('../views/test'),
  },
  {
    path: '/ticket',
    name: 'ticket',
    component: () => import('../components/HyTicket'),
  },

  {
    path: '/mfticket',
    name: 'mfticket',
    component: () => import('../components/MfTicket'),
  },


]

const router = new VueRouter({
  // mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach((to, from, next) => {
  window.scrollTo(0, 0);
  next();
})
export default router
